"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BindingOnSyntax = void 0;
var binding_when_syntax_1 = require("./binding_when_syntax");
var BindingOnSyntax = (function () {
    function BindingOnSyntax(binding) {
        this._binding = binding;
    }
    BindingOnSyntax.prototype.onActivation = function (handler) {
        this._binding.onActivation = handler;
        return new binding_when_syntax_1.BindingWhenSyntax(this._binding);
    };
    return BindingOnSyntax;
}());
exports.BindingOnSyntax = BindingOnSyntax;
